import React, { useEffect, useState } from "react";

const Header = ({ user, onLogout }) => {
  const handleLogin = () => {
    window.location.href = "/login";
  };

  onLogout = () => {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("authToken");
    document.location.href = "/";
    user = null;
  };

  const storedTheme = localStorage.getItem("theme") || "light";
  const [theme, setTheme] = useState(storedTheme);

  // Aplicar la clase al `body` cuando cambia el tema
  useEffect(() => {
    document.body.classList.toggle("dark-mode", theme === "dark");
    localStorage.setItem("theme", theme); // Guardar el tema en localStorage
  }, [theme]);

  // Alternar entre los temas "light" y "dark"
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <header class="azheader border-bottom ">
      <div class="d-flex bd-highlight">
        <div class="p-2 flex-grow-1 bd-highlight">
          <a href="/" style={{ textDecoration: "none" }}>
            <img
              src="img/favicon.png"
              style={{ verticalAlign: "bottom", marginRight: "10px" }}
              alt="LOGO"
            />
            <span class="fs-3"></span>
          </a>
        </div>
        <div class="py-4 px-0 bd-highlight ">
          <button className="btn btn-outline-light me-3" onClick={toggleTheme}>
            <i
              className={`bi fs-5 ${
                theme === "dark" ? "bi-lightbulb" : "bi-moon"
              }`}
            ></i>
          </button>
        </div>
        <div class="py-4 px-2 bd-highlight ">
          {user ? (
            <div className="dropdown-toggle">
              <img
                src={user.profilePicture}
                alt={user.email}
                aria-expanded="false"
                aria-haspopup="true"
                v-pre="true"
                role="button"
                className="rounded-circle"
                width="50"
                height="50"
                data-bs-toggle="dropdown"
                crossOrigin="anonymous"
                style={{ cursor: "pointer" }}
              />
              <ul className="dropdown-menu">
                <li>
                  <button className="dropdown-item" onClick={onLogout}>
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          ) : (
            <button
              className="btn btn-outline-light "
              id="bt_login"
              onClick={handleLogin}
            >
              <i className="bi bi-person-circle fs-5"></i> Login
            </button>
          )}
        </div>
      </div>
 
    </header>
  );
};

export default Header;
